// Bilingual labels for Phase 2 factory module.
export const FACT = {
  en: {
    factory: "Factory",
    wip_board: "Factory WIP", grn: "Goods Receipt (GRN)", pieces: "Pieces", piece_locator: "Piece Locator",
    despatch: "Despatch", despatch_builder: "Despatch Builder", finishing: "Finishing", stock_on_hand: "Stock on Hand",
    ready_despatch: "Ready for Despatch", vendor_followup: "Vendor Follow-up", throughput: "Throughput",
    gate_inspection: "Gate Inspection", disposition: "Dispositions", fixings: "Fixing Records",
    intake_category: "Intake Category", finished: "Finished", qc_issue: "QC Issue", unfinished: "Unfinished",
    source_type: "Source Type", weaver_delivery: "Weaver delivery", trading_fg: "Trading — FG", trading_sf: "Trading — SF", in_house: "In-house",
    stage: "Stage", location: "Location", code: "Code", design: "Design", colour: "Colour", size: "Size", sq_ft: "Sq ft",
    add_piece: "Add piece", scan_piece: "Scan piece", update_location: "Update location",
    op: "Op", start: "Start", finish: "Finish", n_a: "N/A", n_a_reason: "N/A reason", record: "Record",
    critical: "Critical", major: "Major", minor: "Minor",
    counter_sign: "Counter-sign", pass_: "Pass", fail_rework: "Fail → Rework", fail_reject: "Fail → Reject",
    add_defect: "Add defect", photos: "Photos", checklist: "Checklist", measurements: "Measurements",
    grn_number: "GRN #", challan: "Challan ref", vehicle: "Vehicle", expected_count: "Expected count",
    print_qr_labels: "Print QR labels (A4 · 12)", back: "Back",
    packaging_checklist: "Packaging checklist", approve_despatch: "Approve despatch",
    rework_count: "Rework", overdue: "Overdue >7 days",
    log_followup: "Log follow-up", days_since: "Days since update", vendor_status: "Vendor status",
    in_production: "In production", ready_at_vendor: "Ready at vendor end", delayed: "Delayed",
    expected_date: "Expected date", flag_problem: "Flag problem",
  },
  hi: {
    factory: "फैक्ट्री",
    wip_board: "फैक्ट्री WIP", grn: "माल प्राप्ति (GRN)", pieces: "टुकड़े", piece_locator: "टुकड़ा खोजें",
    despatch: "प्रेषण", despatch_builder: "प्रेषण बनाएँ", finishing: "फिनिशिंग", stock_on_hand: "उपलब्ध स्टॉक",
    ready_despatch: "प्रेषण के लिए तैयार", vendor_followup: "वेंडर फॉलो-अप", throughput: "थ्रूपुट",
    gate_inspection: "गेट निरीक्षण", disposition: "निर्णय", fixings: "सुधार रिकॉर्ड",
    intake_category: "प्रवेश श्रेणी", finished: "पूर्ण", qc_issue: "QC समस्या", unfinished: "अपूर्ण",
    source_type: "स्रोत", weaver_delivery: "बुनकर से", trading_fg: "व्यापार — FG", trading_sf: "व्यापार — SF", in_house: "इन-हाउस",
    stage: "चरण", location: "स्थान", code: "कोड", design: "डिज़ाइन", colour: "रंग", size: "आकार", sq_ft: "वर्ग फुट",
    add_piece: "टुकड़ा जोड़ें", scan_piece: "टुकड़ा स्कैन करें", update_location: "स्थान बदलें",
    op: "क्रिया", start: "शुरू", finish: "पूरा", n_a: "N/A", n_a_reason: "N/A कारण", record: "दर्ज करें",
    critical: "गंभीर", major: "बड़ा", minor: "छोटा",
    counter_sign: "काउंटर-साइन", pass_: "पास", fail_rework: "फेल → रीवर्क", fail_reject: "फेल → रिजेक्ट",
    add_defect: "दोष जोड़ें", photos: "फोटो", checklist: "चेकलिस्ट", measurements: "मापन",
    grn_number: "GRN #", challan: "चालान संदर्भ", vehicle: "वाहन", expected_count: "अपेक्षित संख्या",
    print_qr_labels: "QR लेबल प्रिंट (A4 · 12)", back: "वापस",
    packaging_checklist: "पैकेजिंग चेकलिस्ट", approve_despatch: "प्रेषण स्वीकृत करें",
    rework_count: "रीवर्क", overdue: "7+ दिन बाकी",
    log_followup: "फॉलो-अप दर्ज करें", days_since: "पिछले अपडेट से दिन", vendor_status: "वेंडर स्थिति",
    in_production: "उत्पादन में", ready_at_vendor: "वेंडर के पास तैयार", delayed: "देरी",
    expected_date: "अपेक्षित तिथि", flag_problem: "समस्या दर्ज करें",
  },
};

export const useFact = (lang) => (k) => (FACT[lang] || FACT.en)[k] || k;

export const STAGES = [
  "Received", "Post-Weave QC", "Finishing", "Post-Wash QC", "Final QC", "Ready for Despatch", "Despatched",
];
export const STAGE_HI = {
  "Received": "प्राप्त", "Post-Weave QC": "पोस्ट-वीव QC", "Finishing": "फिनिशिंग",
  "Post-Wash QC": "पोस्ट-वॉश QC", "Final QC": "अंतिम QC", "Ready for Despatch": "प्रेषण के लिए तैयार",
  "Despatched": "प्रेषित", "Rework": "रीवर्क", "Rejected": "अस्वीकृत",
};

export const PACKAGING_ITEMS = [
  { key: "rolled_pile_inward", en: "Rolled pile-inward, polythene sealed", hi: "पाइल-अंदर लपेटा, पॉलिथीन सील" },
  { key: "brand_label", en: "Brand + \"Handmade in India\" labels", hi: "ब्रांड + हैंडमेड-इन-इंडिया लेबल" },
  { key: "care_label", en: "Care & composition labels (ISO 3758)", hi: "देखभाल व संरचना लेबल (ISO 3758)" },
  { key: "coa_included", en: "Certificate of Authenticity included", hi: "प्रमाणिकता प्रमाणपत्र सम्मिलित" },
  { key: "qr_scanned", en: "QR / piece code scanned & matches", hi: "QR / कोड स्कैन और मेल" },
  { key: "weight_recorded", en: "Weight & dimensions recorded", hi: "वजन व माप दर्ज" },
  { key: "packing_list_created", en: "Packing list line created", hi: "पैकिंग लिस्ट पंक्ति बनाई" },
];
